export default __webpack_public_path__ + "static/media/car-1.f9f4c711.svg";